import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { Box } from '../../Box';
import {
  cardContainerStyles,
  contentContainerStyles,
  imageContainerStyles,
} from '../PackageCard.styles';
import type { PackageCardOrientation } from '../PackageCard.types';

type PackageCardSkeletonProps = {
  className?: string;
  hasContentBackground: boolean;
  orientation: PackageCardOrientation;
};

const PackageCardSkeleton = ({
  className,
  hasContentBackground,
  orientation,
}: PackageCardSkeletonProps) => (
  <Box
    css={cardContainerStyles(orientation, hasContentBackground, false)}
    className={className}
  >
    <Box
      overflow="hidden"
      borderRadius="var(--spacing-4)"
      css={imageContainerStyles(orientation)}
    >
      <Skeleton width="100%" height="100%" borderRadius={16} />
    </Box>
    <Box css={contentContainerStyles(orientation, hasContentBackground)}>
      <Box
        display="flex"
        flexDirection="column"
        gap="var(--spacing-1)"
        mb="var(--spacing-1)"
      >
        <Skeleton width="80%" height={16} borderRadius={4} />
        <Skeleton width="60%" height={14} borderRadius={4} />
        <Skeleton width="40%" height={14} borderRadius={4} />
      </Box>
    </Box>
  </Box>
);

export default PackageCardSkeleton;
